import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=9277f0ac&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9277f0ac')) {
      api.createRecord('9277f0ac', component.options)
    } else {
      api.reload('9277f0ac', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=9277f0ac&", function () {
      api.rerender('9277f0ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uLypWyNWd67a/JS/offershelp.vue"
export default component.exports